/* SelectedWallpapers — adaptieve m2-prijsregel (12-06-2026).
   Past de volledige prijsregel ("€ 124 per meter (M1) | € 96 m²") op één
   regel, dan blijft het één regel met pipe. Past het niet, dan krijgt de
   .price-unit-suffix de class m2-on-own-line en toont sw-custom.css de
   m²-prijs als eigen zin ("€ 96 per m²") op de volgende regel.
   Hermeet bij resize, font-load en dynamische content (AJAX/quick-view). */
(function () {
  'use strict';

  function blockAncestor(el) {
    var node = el.parentElement;
    while (node && node !== document.body) {
      var d = window.getComputedStyle(node).display || '';
      if (d.indexOf('inline') !== 0) return node;
      node = node.parentElement;
    }
    return node || document.body;
  }

  function measure() {
    var suffixes = document.querySelectorAll('.price-unit-suffix');
    if (!suffixes.length) return;
    var i;
    for (i = 0; i < suffixes.length; i++) {
      suffixes[i].classList.remove('m2-on-own-line');
    }
    for (i = 0; i < suffixes.length; i++) {
      var s = suffixes[i];
      var part = s.querySelector('.price-m2-part');
      var anchor = s.parentElement;
      if (!part || !anchor) continue;
      var pr = part.getBoundingClientRect();
      if (!pr.height) continue; /* verborgen, bv. gesloten quick-view */
      var wrapped = pr.top - anchor.getBoundingClientRect().top > 12;
      var overflows = pr.right - blockAncestor(s).getBoundingClientRect().right > 1;
      if (wrapped || overflows) s.classList.add('m2-on-own-line');
    }
  }

  var t;
  function queue() {
    clearTimeout(t);
    t = setTimeout(measure, 120);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', measure);
  } else {
    measure();
  }
  window.addEventListener('load', measure);
  window.addEventListener('resize', queue);
  document.addEventListener('click', queue, true);
  document.addEventListener('shopify:section:load', queue);
  if (document.fonts && document.fonts.ready && document.fonts.ready.then) {
    document.fonts.ready.then(queue);
  }
  if (window.MutationObserver) {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes && muts[i].addedNodes.length) {
          queue();
          return;
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
